import './ImageUploadModal.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCloud, faExclamationTriangle, faUpload } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { EnableFor } from '../../../containers/EnableForRole';
import { useDatasetPermissions } from '../datasets.permissions';
import { IImageUploadProps, ImageUploadForm } from './ImageUploadForm';

library.add(faUpload, faCloud, faExclamationTriangle);

interface IImageUploadModalProps extends IImageUploadProps {
  showModal: boolean;
  toggleUploadModal(): void;
}

export const ImageUploadModal = observer((props: IImageUploadModalProps): ReactElement => {
  const { t } = useTranslator();
  const canUploadImages = useDatasetPermissions().canUploadImages(props.datasetStatus, props.datasetCreatorId);

  const onCancel = (): void => {
    props.cleanImagesFromFile();
    props.toggleUploadModal();
  };

  const toggleUploadModal = (): void => {
    props.toggleUploadModal();
  };

  return (
    <>
      <EnableFor hasPermission={canUploadImages}>
        <Button
          id='publish-dataset-button'
          onClick={toggleUploadModal}
          title={t('add_images')}
        >
          {t('add_images')}
        </Button>
      </EnableFor>
      <S_Modal
        isOpen={props.showModal}
        toggle={toggleUploadModal}
        className='upload-modal'
        headerText={t('add_images')}
      >
        <ImageUploadForm
          {...props}
          onCancel={onCancel}
        />
      </S_Modal>
    </>
  );
});
